import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FunnelLayout from "./FunnelLayout";
import "./CommonNewFunnel.css";
import T1 from "../../assets/images/t1.png";
import T2 from "../../assets/images/t2.png";
import T3 from "../../assets/images/t3.png";
import T4 from "../../assets/images/t4.png";

const LS_KEY = "glp1_intake_step2";

type Step2State = {
  acknowledged: boolean;
};

const DEFAULT: Step2State = {
  acknowledged: true,
};

const TESTIMONIALS = [
  {
    id: "t1",
    img: T1,
    caption:
      "<strong>Sandra dropped 40 pounds</strong> and improved her sleep and A1C levels",
  },
  {
    id: "t2",
    img: T2,
    caption:
      "Rebecca dropped 86 pounds and <strong>found her confidence</strong>",
  },
  {
    id: "t3",
    img: T3,
    caption:
      "Dan lost 28 pounds while <strong>maintaining his muscle mass</strong>",
  },
  {
    id: "t4",
    img: T4,
    caption:
      "Christian entered his freshman year in college as <strong> a new man</strong>",
  },
];

const NewFunnelStep2: React.FC = () => {
  const navigate = useNavigate();
  const [state, setState] = useState<Step2State>(DEFAULT);

  useEffect(() => {
    const saved = localStorage.getItem(LS_KEY);
    if (saved) {
      try {
        setState(JSON.parse(saved));
      } catch (e) {
        console.log(e);
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(LS_KEY, JSON.stringify(state));
  }, [state]);

  const next = () => {
    setState({ acknowledged: true });
    navigate("/glp1/intake-form/step-2");
  };

  return (
    <FunnelLayout>
      <div className="funnel-step2">
        <h1 className="step2-title">
          “When nothing else worked…
          <br />
          <span>CLAYA did!”</span>
        </h1>

        <div className="step2-testimonials">
          {TESTIMONIALS.map((item) => (
            <div key={item.id} className="step2-testimonial">
              <div className="step2-testimonial__imgWrap">
                {item.img ? (
                  <img
                    className="step2-testimonial__img"
                    src={item.img}
                    alt="Before and after"
                  />
                ) : (
                  <div className="step2-testimonial__imgPlaceholder" />
                )}
              </div>

              {/* ✅ this is the only important change */}
              <div
                className="step2-testimonial__caption"
                dangerouslySetInnerHTML={{ __html: item.caption }}
              />

              <div className="step2-testimonial__divider" />
            </div>
          ))}
        </div>

        <div className="step2-question">
          Are you ready for your <br /> next chapter?
        </div>

        <button className="next-btn" onClick={next}>
          Next →
        </button>
      </div>
    </FunnelLayout>
  );
};

export default NewFunnelStep2;